// extracted by mini-css-extract-plugin
export default {"textarea-box":"Editor_textarea-box__BAUph","textarea":"Editor_textarea__qjqkc","label":"Editor_label__zOHeG","warning_text":"Editor_warning_text__OY4NV"};